<template>
	<fragment>
		<common-header
			name="직장맘 지원센터 관리자 시스템"
		></common-header>

		<section ref="container" class="container text-center" 
			style="display: flex; align-items: center; justify-content: center;">
			<img style="opacity: 0.6;" src="images/basic/main.png">
		</section>

		<common-footer></common-footer>
	</fragment>
</template>

<script>
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'

export default {
	// 컴포넌트명
	name: "ViewMain",
	
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		CommonHeader,
		CommonFooter,
	},
}
</script>